module.exports = __webpack_public_path__ + "img/form_enabled.0b738129.svg";